export enum BreadcrumbCategory {
  MENU = "menu",
  LINK = "link",
}
